import React from 'react';

/**
 * Button component with primary and secondary variants
 * Design: Black/white minimalist, hard edges, uppercase text
 */
export default function Button({
  children,
  variant = 'primary',
  type = 'button',
  disabled = false,
  onClick,
  className = '',
  fullWidth = false,
  size = 'md',
  ...props
}) {
  const baseStyles = 'font-mono font-semibold uppercase tracking-wider border-2 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    primary: 'bg-black text-white border-black hover:bg-white hover:text-black disabled:hover:bg-black disabled:hover:text-white',
    secondary: 'bg-white text-black border-black hover:bg-black hover:text-white disabled:hover:bg-white disabled:hover:text-black',
    danger: 'bg-white text-red-600 border-red-600 hover:bg-red-600 hover:text-white disabled:hover:bg-white disabled:hover:text-red-600',
    ghost: 'bg-transparent text-black border-transparent hover:border-black disabled:hover:border-transparent',
  };

  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base',
  };

  const widthClass = fullWidth ? 'w-full' : '';

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
